/**
 * After web OAuth redirect, apply signup consents captured before leaving for the provider.
 */

import { Platform } from 'react-native'

import { supabase } from '../../lib/supabase'
import {
  OAUTH_SIGNUP_CONSENT_STORAGE_KEY,
  parseOauthSignupConsentPending,
} from '../constants/signupConsent.constants'
import { syncSignupPrivacyConsents } from './syncSignupPrivacyConsents.helper'

export async function flushOAuthWebSignupConsentsIfPending(): Promise<void> {
  if (Platform.OS !== 'web') return
  if (typeof sessionStorage === 'undefined') return

  const raw = sessionStorage.getItem(OAUTH_SIGNUP_CONSENT_STORAGE_KEY)
  sessionStorage.removeItem(OAUTH_SIGNUP_CONSENT_STORAGE_KEY)

  const parsed = parseOauthSignupConsentPending(raw)
  if (!parsed?.legalTermsAccepted) return

  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  if (!token) return

  await syncSignupPrivacyConsents(token, {
    marketingEmailOptIn: parsed.marketingEmailOptIn,
    legalTermsAccepted: true,
  })
}
